import { useTranslation } from 'react-i18next';

import { Typography } from '@/components';
import { ASSETS_BASE_URL } from '@/config';

import { OfferDetails } from '../../types';

export type OthersSectionProps = {
  readonly offer: OfferDetails;
};

export function OthersSection({ offer }: OthersSectionProps) {
  const { t } = useTranslation(['offers']);

  return (
    <section className="mb-6">
      <Typography as="h4" color="primary" size="title" weight="semibold">
        {t('Additional Information & Documents')}
      </Typography>
      <Typography as="p" size="body-3" color="secondary" weight="normal" className="mt-1 italic">
        {t(
          "This section provides additional information and documents relevant to clarify the buyer's position, terms, or requirements."
        )}
      </Typography>

      <div className="mt-6">
        <Typography as="p" size="body-2" weight="semibold">
          {t('Additional Information')}
        </Typography>
        <Typography as="span" size="body-2" color="primary" className="whitespace-pre-line">
          {offer?.comments}
        </Typography>
      </div>

      <div className="mt-6">
        <Typography as="p" size="body-2" weight="semibold">
          {t('Other relevant documents')}
        </Typography>
        {offer?.file ? (
          <Typography as="span" size="body-2">
            <a href={`${ASSETS_BASE_URL}/${offer.file}`} target="_blank" rel="noreferrer" className="text-primary-700">
              {t('Press to see the document')}
            </a>
          </Typography>
        ) : (
          <Typography as="span" size="body-2" color="primary">
            {t('No document provided')}
          </Typography>
        )}
      </div>
    </section>
  );
}
